<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    toolbarColor: {
      type: String,
      default: 'white',
    },
  },

  data() {
    return {
      activeTab: null,
      tabs: [],
    }
  },

  mounted() {
    this.tabs = this.$refs.tabItems.$children
  },
}
</script>

<template>
  <div class="elevation-1">
    <!-- VToolbar -->
    <VToolbar :color="toolbarColor" flat tabs>
      <VToolbarTitle :class="`${color}--text`">
        {{ title }}
      </VToolbarTitle>

      <VTabs slot="extension" v-model="activeTab" color="white">
        <VTabsSlider :color="color" />

        <VTab v-for="tab in tabs" :key="tab.name">
          {{ tab.name }}
        </VTab>
      </VTabs>
    </VToolbar>
    <!-- End of VToolbar -->

    <!-- VTabsItems -->
    <VTabsItems ref="tabItems" v-model="activeTab">
      <slot />
    </VTabsItems>
    <!-- End of VTabsItems -->
  </div>
</template>
